export enum SituacaoContribuinteEmpresaEnum {
    NaoContribuinteIcms = 1,
    ContribuinteIcms = 2,
    ContribuinteExclusivoIbsCbs = 3,
}
